'use strict';

import "./css/styles.css";

//import "./components/Engine/cfJS";
import Engine from "./components/Engine/Engine";
import cfJS from "./components/Engine/cfJS";
import "./components/Button/Button";
import "./components/CodeMirror/CodeMirror";
import "./components/Notice/Notice";
import "./components/Input/Input";
import "./components/Tab/Tab";
import "./components/Tooltip/Tooltip";
import "./components/Dialog/Dialog";

window.engine = Engine;
window.cfJS = cfJS;

/*import CreatorOfTheNewPagesClass from './components/core.js';

window.CreatorOfTheNewPages = function (id, options) {
	return new CreatorOfTheNewPagesClass(id, options);
};*/